import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";
import Card from "../../components/card/Card";
import { TextInput } from "../../components/inputs/TextInput";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import Form from "../../components/inputs/Form";
import { login } from "../../server/fetchFunctions";
import { LoaderButton } from "../../components/loader/Loader";
import { themeColor } from "../../lib/themeColor";

export default function Login() {
  const navigate = useNavigate();

  const [credentials, setCredentials] = useState<{ [key: string]: any }>({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    themeColor({});
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // Basic validation
    setIsLoading(true);
    if (!credentials.username || !credentials.password) {
      return;
    }

    await login("auth", credentials);
    setIsLoading(false);
    navigate("/jobs", { replace: true });
  };

  return (
    <div className="login-container">
      <Form onSubmit={handleSubmit}>
        <Card>
          <h2>Bejelentkezés</h2>
          <TextInput
            labelWidth={120}
            stateKey="username"
            state={credentials}
            setState={setCredentials}
            inlineLabel="Felhasználó"
            required
          />
          <TextInput
            labelWidth={120}
            type="password"
            stateKey="password"
            state={credentials}
            setState={setCredentials}
            inlineLabel="Jelszó"
            required
          />
          <PrimaryButton btn={{ type: "submit", text: "Bejelentkezés" }} />
          <p style={{ textDecoration: "underline" }}>Elfelejtett jelszó</p>
        </Card>
      </Form>
    </div>
  );
}
